document.addEventListener( 'DOMContentLoaded', event => {

	// photoslurp

	document.querySelectorAll('.ps-image').forEach( li => {
		li.addEventListener( 'click', e => gtag('event', 'click_photoslurp') );
	} );

	document.querySelectorAll('.ps-prev, .ps-next').forEach( span => {
		span.addEventListener( 'click', e => gtag('event', 'scroll_photoslurp') );
	} );


	// press

	document.querySelectorAll('.section-partners-opinions-rocket__partners__logo__image').forEach( div => {
		div.addEventListener( 'click', e => gtag('event', 'click_press') );
	} );


	// product

	document.querySelectorAll('.swatches-rocket__list__li__link').forEach( a => {
		a.addEventListener( 'click', e => gtag('event', 'click_bubble') );
	} );

	document.querySelectorAll('.section-caracteristicas-destacadas .owl-prev, .section-caracteristicas-destacadas .owl-next').forEach( button => {
		button.addEventListener( 'click', e => gtag('event', 'scroll_product-features') );
	} );

	document.querySelectorAll('.section-seo-description details').forEach( details => {
		details.addEventListener( 'toggle', e => {
			if (e.currentTarget.open) gtag('event', 'open_product-faq');
		} );
	} );


	// trustpilot

	document.querySelectorAll('.tp-widget-review').forEach( div => {
		div.addEventListener( 'click', e => gtag('event', 'click_trustpilot') );
	} );

	document.querySelectorAll('#review-arrow-left, #review-arrow-right').forEach( div => {
		div.addEventListener( 'click', e => gtag('event', 'scroll_trustpilot') );
	} );


	// country selector

	document.querySelectorAll('#country-list-footer .disclosure-list__option').forEach( a => {
		a.addEventListener( 'click', e => {
			gtag( 'event', 'select_country', { iso_code: a.dataset.value } );
		} );
	} );


	// navbar main menu links (desktop #main-nav + mobile drawer; all levels)

	function navMenuLevel( a ) {
		if ( a.closest('.navigation__tier-4') ) return 'tier_4';
		if ( a.closest('.navigation__tier-3') ) return 'tier_3';
		if ( a.closest('.navigation__tier-2') ) return 'tier_2';
		return 'tier_1';
	}

	// normalize a nav link for analytics: internal links become a locale-agnostic
	// path so all language versions aggregate into one row; external links keep
	// their full URL so they don't collide with internal paths
	function navMenuPath( a ) {
		if ( a.hostname !== location.hostname ) return a.href;
		let path = a.pathname || '/';
		// strip leading locale prefix (non-default Shopify languages: de, es, fr, it)
		path = path.replace( /^\/(de|es|fr|it)(?=\/|$)/, '' );
		return path || '/';
	}

	document.querySelectorAll('#main-nav a[href], .mobile-navigation-drawer a[href]').forEach( a => {
		// only track links that navigate; '#' toggles/close/back buttons are skipped
		const href = a.getAttribute('href');
		if ( !href || href === '#' ) return;

		a.addEventListener( 'click', e => {
			gtag( 'event', 'click_navbar_menu', {
				menu_item: a.textContent.trim(),
				link_url: navMenuPath( a ),
				menu_level: navMenuLevel( a )
			} );
		} );
	} );


	// product card quick add-to-cart button (collection / list, desktop & mobile)

	document.querySelectorAll('.form-addToCart-quickbuy').forEach( form => {
		form.addEventListener( 'submit', e => {
			gtag( 'event', 'click_card_quick_atc', {
				product_id: form.dataset.productId,
				variant_id: form.dataset.variantId
			} );
		} );
	} );


	// product page main add-to-cart button (.btn-meller, desktop & mobile)

	document.querySelectorAll('.addToCart.btn-meller').forEach( button => {
		button.addEventListener( 'click', e => {
			const form = button.closest('form');
			gtag( 'event', 'click_pdp_atc', {
				product_id: form ? form.dataset.productId : undefined,
				variant_id: form ? form.querySelector('[name="id"]')?.value : undefined
			} );
		} );
	} );

} );